import type { RowDto } from '@bldsoft/cappie/api/wbs'
import type { AppearanceRow } from '@setplex/tria-api'
import type { AppearanceBanner } from '@setplex/tria-api/src/entities/appearance'
import type { ApiType } from '../../../shared/schemas'

import * as v from 'valibot'
import { slice } from '../../../shared/schemas'
import { FALLBACK_STYLE, StyleSchema } from './styles'

export const FALLBACK_ROW_STYLE = {
  posterSize: 'M',
  posterOrientation: 'VERTICAL',
  background: FALLBACK_STYLE,
} as const

export const WbsApiResourceSchema = v.pipe(
  v.string(),
  v.rawTransform(({ dataset, addIssue, NEVER }) => {
    try {
      // create URL object with dummy base url to parse given relative path as absolute URL
      // do not use "window.location.origin" as base URL in case we will use this schema in node.js
      const url = new URL(dataset.value, 'http://dumb')
      return {
        path: url.pathname,
        search: url.searchParams,
      }
    } catch (e) {
      addIssue({ message: `Invalid API resource: ${e}` })
      return NEVER
    }
  })
)

export const RowStyleSchema = v.object({
  posterSize: v.nullish(v.picklist(['S', 'M', 'L']), 'M'),
  posterOrientation: v.nullish(
    v.picklist(['HORIZONTAL', 'VERTICAL']),
    'VERTICAL'
  ),
  background: v.nullish(StyleSchema, FALLBACK_STYLE),
  topContent: v.nullish(v.boolean(), false),
})

// TODO mocked - resolve later - not exist or updated type in @bldsoft/cappie/api/wbs
type BannerDto = Omit<RowDto, 'title' | 'contentType' | 'style'> & {
  title?: string | null
  contentType?: RowDto['contentType'] | 'BANNER_CAROUSEL'
  style?: RowDto['style'] | null
}

export const BannerSchema = v.object({
  id: v.string(),
  refreshable: v.boolean(),
  contentType: v.picklist(['BANNER_CAROUSEL']),
  resource: WbsApiResourceSchema,
  paged: v.boolean(),
}) satisfies ApiType<BannerDto, AppearanceBanner>

export const RowSchema = v.object({
  id: v.string(),
  title: v.string(),
  localizedTitleKey: v.nullish(v.string(), () => undefined),
  description: v.nullish(v.string(), () => undefined),
  refreshable: v.boolean(),
  contentType: v.picklist([
    'LIVE_EVENT',
    'MIXED',
    'PARTNER_PRODUCT',
    'TV_BUNDLE',
    'TV_CHANNEL',
    'TV_SHOW_BUNDLE',
    'TV_SHOW',
    'VOD_BUNDLE',
    'VOD',
    'MOTN_VOD',
    'MOTN_TV_SHOW',
  ]),
  resource: WbsApiResourceSchema,
  paged: v.boolean(),
  style: v.nullish(RowStyleSchema, FALLBACK_ROW_STYLE),
}) satisfies ApiType<RowDto, AppearanceRow>

export const ComponentSchema = v.union([RowSchema, BannerSchema])

export const RowsPageSchema = slice(ComponentSchema)
